import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ParentChildService } from '../../../../../components/parentchild/parentchild.service';
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import { ConfirmationService, Paginator } from 'primeng/primeng';
import { DropdownModule } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { addParentChildModel,motherChildModel } from '../../../../../components/parentchild/addparent/addparentchild.model';
import { element } from 'protractor';
import * as html2pdf from "html2pdf.js"
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'parentchild_advancedQ',
  templateUrl: 'parentchild_advancedQ.component.html',
  styleUrls: ['parentchild_advancedQ.component.scss']
})

export class SubParentChildAdvacnedQComponent implements OnInit {
  @ViewChild('paginator') paginator: Paginator
  // display: boolean = false;
  // display = "none";
  // editDisplay = "none";
  // editDisplay:boolean=false;

  /*public childInfo: any;
  public childview: any;
  public Mappeddata: any;
  public Sections: any;
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public addeventmodel: any;
  public StandardId: any;
  public SectionId: any;
  public searchString:any;
  public input:any;
  public spinnershow: boolean = false;
  public selectedRows: number = 10;
  public addparentchildmodel=new addParentChildModel();*/

  public Sections: any;
  public spinnershow: boolean = false;
  public data: any;
  public data2: any;
  public data3: any;
  public data4: any;
  public siblings: any;
  public isUserSchoolAdmin: boolean = false;
  public isUpdating: boolean = false;
  public isPrinting: boolean = false;
  public isHidingButtons: boolean = false;
  public isMissingAPIFieldsShowing: boolean = false;
  public loading = "none";
  public studentId = ''
  public childid = ''

  tempSection: any;
  public CurrentChild : any;

  constructor(private parentChildService: ParentChildService,private route: ActivatedRoute,private noticeboardService: NoticeboardService, private localStorage: LocalStorageService, private messageService: MessageService, private confirmationService: ConfirmationService, private parentchildservice: ParentChildService, private router: Router) {
    this.Sections =null;
    // this.Sections=true;

  }
  ngOnInit() {
    
        this.parentChildService.getHIeduChildInfo(this.studentId).subscribe(data => {
          let x: any = data
          this.data = x.items[0]
          console.log("getHIeduChildInfo", x);
          try {
            if(this.data.hasOwnProperty("DateOfBirth") && this.data['DateOfBirth'] != undefined && this.data['DateOfBirth'] != null){
              this.data['DateOfBirth'] = this.formatDateReceive(this.data['DateOfBirth']);
            }
          } catch (error) {
            //window.location.reload();
          }

          if(this.data['OtherParentFirstName'] == null){
            this.data['OtherParentFirstName'] = "";
          }
          if(this.data['OtherParentLastName'] == null){
            this.data['OtherParentLastName'] = "";
          }

          if(this.data['ParentsGender'] == "Female"){
            this.data['FatherName'] = this.data['OtherParentFirstName'] + " " + this.data['OtherParentLastName'];
            this.data['FatheerContactNo'] = this.data['OtherParentPhoneNumber'];
            this.data['FatherEmail'] = this.data['OtherParentEmailAddress'];
            this.data['FatherSMSUser'] = this.data['IsOtherParentSMSUser'] ? true : false;
            this.data['MotherName'] = this.data['ParentsName'];
            this.data['MotherContactNo'] = this.data['PhoneNumber'];
            this.data['MotherEmail'] = this.data['EmailAddress'];
            this.data['MotherSMSUser'] = this.data['Issmsuser'];
          }else{
            this.data['FatherName'] = this.data['ParentsName'];
            this.data['FatheerContactNo'] = this.data['PhoneNumber'];
            this.data['FatherEmail'] = this.data['EmailAddress'];
            this.data['FatherSMSUser'] = this.data['Issmsuser'];
            this.data['MotherName'] = this.data['OtherParentFirstName'] + " " + this.data['OtherParentLastName'];
            this.data['MotherContactNo'] = this.data['OtherParentPhoneNumber'];
            this.data['MotherEmail'] = this.data['OtherParentEmailAddress'];
            this.data['MotherSMSUser'] = this.data['IsOtherParentSMSUser'] ? true : false;
          }
        }, err => {
          console.log(err);
        }, () => {
          console.log('sucesss');
          this.spinnershow = false;
          setTimeout(() => {
            this.loading = "none";
          }, 300);
        }); 
    //   }else{
    //     this.router.navigate([`parent/${this.CurrentChild.ChildId}/not-enabled`]);
    //   }

    // })
  }
  //  HieduStudentDelete(childId,Batchid){
  //   this.parentChildService.deleteHiChildInfo(childId,Batchid)
  //   .subscribe(data=>{
  //     console.log("HieduStudentDelete");
  //   })
  // }
  // this.parentChildService.getHIeduChildInfo(this.studentId).subscribe(data => {
  //   let x: any = data
  //   this.data = x.items[0]
  //   console.log("getHIeduChildInfo", x);

  HieduStudentDelete(childid) {
    this.parentChildService.deleteHiChildInfo(this.childid)
      .subscribe(data => {

        console.log("HieduStudentDelete");

      });
  }
  PrintPdf() {
    this.isHidingButtons = true;
    this.isPrinting = true;

    const options = {
      filename: this.data.ChildFirstName + " " + this.data.ChildLastName,
      margin: [15, 15, 15, 15],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      html2canvas: {
        dpi: 192,
        scale: 2,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('for_print')

    html2pdf()
      .from(content)
      .set(options)
      .save()
      .then(() => {
        this.isPrinting = false;
        this.isHidingButtons = false;
      });
  }

  navigateChild(t){
    this.router.navigate(['/parent/1221/student-profile/' + t]).then(() => {
      this.getHieduChildsDetails(t);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });;
  }

  isNumeric(str) {
    return !isNaN(str) && !isNaN(parseFloat(str))
  }

  ContactNoChanged(e,f,g){
    if(e.length >= 1 && e.substring(0, 1) == "0"){
      e = "+94" + e.substring(1);
    }
    if(e.length >= 2 && (e.substring(0, 2) != "94" && e.substring(0, 2) != "+9")){
      e = "+94" + e.substring(2);
    }
    if(e.length >= 3 && e.substring(0, 3) != "+94"){
      e = "+94" + e.substring(3);
    }
    if(e.length >= 2 && e.substring(0, 2) == "94"){
      e = "+" + e;
    }

    e = e.replace(" ", "").replace("e", "");

    this.data[f] = e;
    if(e.length == 12 && e.substring(0, 3) == "+94" && e.substring(3, 4) != "0" && this.isNumeric(Number(e.substring(1)))){
      this.data[g] = true;
    }else{
      this.data[g] = false;
    }
  }

  editField(t){
    if(this.hasOwnProperty(t)){
      this[t] = !this[t];
    }else{
      this[t] = true;
    }
  }

  formatDateSend(date) {
      var d = new Date(date);

      return d.toISOString();
  }

  formatDateReceive(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
  }

  updateField(t){
    this.isUpdating = true;
    this.spinnershow = true;
    var y = this;
    let x = y.data;

    x["id"] = y.data.id;
    x["ChildId"] = y.data.ChildId;
    x["ChildSectionId"] = y.data.ChildSectionId;
    x["PhoneNumber"] = y.data.PhoneNumber;
    x["ParentsName"] = y.data.ParentsName;
    //x["UserName"] = y.data.UserName;
    //x["Issmsuser"] = y.data.Issmsuser;
    x["EmailAddress"] = y.data.EmailAddress;
    x["ParentsGender"] = y.data.ParentsGender;

    x["ChildFirstName"] = y.data.ChildFirstName;
    x["ChildLastName"] = y.data.ChildLastName;
    x["ChildGender"] = y.data.ChildGender;
    x["ChildGenderId"] = y.data.ChildGenderId;
    //x["ChildGenderId"] = y.data.ChildGenderId;

    /*
    x["Id"] = y.data.id;
    x["childid"] = y.data.ChildId;
    x["childsectionid"] = y.data.SectionId;
    x["PhoneNumber"] = y.data.PhoneNumber;
    //x["FirstName"] = y.data.ChildFirstName;//d
    //x["LastName"] = y.data.ChildLastName;
    x["Username"] = y.data.UserName;
    x["IsSMSUser"] = y.data.Issmsuser;
    x["EmailAddress"] = y.data.EmailAddress;
    x["parentgender"] = y.data.ParentsGender;
    x["childfirstname"] = y.data.ChildFirstName;//d
    x["childlastname"] = y.data.ChildLastName;
    x["childgender"] = y.data.ChildGender;
    x["parentrelation"] = y.data.ParentsRelation;
    x["Picture"] = y.data.Picture;
    x["SchoolId"] = y.data.Schoolid;
    x["school"] = y.data.School;
    x["standard"] = y.data.Standard;
    x["standardid"] = y.data.StandardId;
    x["section"] = y.data.Section;
    x["sectionid"] = y.data.SectionId;
    x["parentcreateddate"] = y.data.Parentcreateddate;
    x["childcreateddate"] = y.data.Childcreateddate;
    x["BloodGroup"] = y.data.BloodGroup;
    x["MedicalConditions"] = y.data.MedicalConditions;
    x["SpecialNeeds"] = y.data.SpecialNeeds;
    x["ClubName"] = y.data.ClubName;
    //x["AdminssionNumber"] = y.data.AdminssionNumber;
    x["RegisterationNumber"] = y.data.RegisterationNumber;
    x["HomeAddress"] = y.data.HomeAddress;
    x["House"] = y.data.House;
    x["Hosteler"] = y.data.Hosteler;
    x["Religion"] = y.data.Religion;
    x["Medium"] = y.data.Medium;
    x["AdmissionYear"] = y.data.AdmissionYear;
    x["LeavingYear"] = y.data.LeavingYear;
    x["Contact1"] = y.data.Contact1;
    x["Relationship1"] = y.data.Relationship1;
    x["MobileNo1"] = y.data.MobileNo1;
    x["Contact2"] = y.data.Contact2;
    x["Relationship2"] = y.data.Relationship2;
    x["MobileNo2"] = y.data.MobileNo2;
    //x["MotherContactNo"] = y.data.MotherContactNo;
    //x["MotherEmail"] = y.data.MotherEmail;
    //x["FatheerContactNo"] = y.data.FatheerContactNo;
    //x["FatherEmail"] = y.data.FatherEmail;
    x["GuardianName"] = y.data.GuardianName;
    x["GuardianContactNo"] = y.data.GuardianContactNo;
    x["GuardianEmail"] = y.data.GuardianEmail;
    x["SportName"] = y.data.SportName;
    x["Prefectship"] = y.data.Prefectship;
    x["Scholarship"] = y.data.Scholarship;
    x["Discipline"] = y.data.Discipline;

    x["DateOfBirth"] = this.formatDateSend(y.data.DateOfBirth);
    //console.log(x["DateOfBirth"]);

    x["Other"] = y.data.Other;
    x["IsFatherPastStudent"] = y.data.IsFatherPastStudent;
    x["IsMotherPastStudent"] = y.data.IsMotherPastStudent;
    x["email"] = y.data.childemail; */

    x["DateOfBirth"] = this.formatDateSend(y.data.DateOfBirth);

    console.log("updateChildInfo", x);

    this.parentchildservice.updateHiChildInfo(x).finally(() => { y.isUpdating = false; y.spinnershow = false; }).subscribe(
      response => {
        y.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Updated Successfully' });
        y[t] = false;
        console.log("success", response);
      },
      error => {
        if(error == undefined){
          y.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Updated Successfully' });
          y[t] = false;
          console.log("success", error);
        }else{
          console.log("error", error);
        }
      });
  }

  /* onSearchChange(searchString) {
    this.searchString = searchString;
    this.getChildsList(this.bigCurrentPage,this.selectedRows);
  }
  private updateCurrentPage(currentPage: number): void {
    setTimeout(() => this.paginator.changePage(currentPage));
  }*/

  private getHieduChildsDetails(id) {
    this.spinnershow = true;
    this.data = {ChildFirstName: '', ChildLastName: ''};
    let data2 = {FirstName: '', Id: null, LastName: '', Sectionname: '', Standardnname: ''};
    this.siblings = [];
    this.siblings.push(data2);
    this.parentchildservice.getHIeduChildInfo(id).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        //console.log("getHieduChildsDetails response", response);
        this.data = response['items'][0];
        console.log("getHieduChildsDetails", this.data);
        
      //  this.getSiblingInfo(id, this.data['id'], this.data['Schoolid']);
        if(this.data['DateOfBirth'] != undefined && this.data['DateOfBirth'] != null){
          this.data['DateOfBirth'] = this.formatDateReceive(this.data['DateOfBirth']);
        }
        if(this.data['OtherParentFirstName'] == null){
          this.data['OtherParentFirstName'] = "";
        }
        if(this.data['OtherParentLastName'] == null){
          this.data['OtherParentLastName'] = "";
        }

        if(this.data['ParentsGender'] == "Female"){
          this.data['FatherName'] = this.data['OtherParentFirstName'] + " " + this.data['OtherParentLastName'];
          this.data['FatheerContactNo'] = this.data['OtherParentPhoneNumber'];
          this.data['FatherEmail'] = this.data['OtherParentEmailAddress'];
          this.data['FatherSMSUser'] = this.data['IsOtherParentSMSUser'] ? true : false;
          this.data['MotherName'] = this.data['ParentsName'];
          this.data['MotherContactNo'] = this.data['PhoneNumber'];
          this.data['MotherEmail'] = this.data['EmailAddress'];
          this.data['MotherSMSUser'] = this.data['Issmsuser'];
        }else{
          this.data['FatherName'] = this.data['ParentsName'];
          this.data['FatheerContactNo'] = this.data['PhoneNumber'];
          this.data['FatherEmail'] = this.data['EmailAddress'];
          this.data['FatherSMSUser'] = this.data['Issmsuser'];
          this.data['MotherName'] = this.data['OtherParentFirstName'] + " " + this.data['OtherParentLastName'];
          this.data['MotherContactNo'] = this.data['OtherParentPhoneNumber'];
          this.data['MotherEmail'] = this.data['OtherParentEmailAddress'];
          this.data['MotherSMSUser'] = this.data['IsOtherParentSMSUser'] ? true : false;
        }

        if(this.data['OtherChildId'] != null){
          this.data['Sibling'] = this.data['otherchildFirstName'] + " " + this.data['otherchildLastName'] + ", " + this.data['otherchildStandardname'] + this.data['otherchildsectionname'];
        }else{
          this.data['Sibling'] = "";
        }


      },
      error => {
        console.log(error);
      });
  }

  private getSiblingInfo(childid,parentid,schoolid) {
    this.spinnershow = true;
    this.parentchildservice.getSiblingInfo(childid,parentid,schoolid).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        console.log("getSiblingInfo", response);
        if(response && response['items'] && /*Object.prototype.toString.call(response['items']) === '[object Array]' && */ response['items'][0]){
          this.siblings = response['items'];
        }
      },
      error => {
        console.log(error);
      });
  }
  /* private getChildsList(pagenum,rows) {
    this.spinnershow = true;
    this.parentchildservice.getChildNameList(pagenum, this.searchString).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
      },
      error => {
      });
  }

  searchDetails() {
    if(!this.StandardId)this.StandardId='';
    if(!this.SectionId) this.SectionId='';
    if(!this.searchString) this.searchString='';
    this.parentchildservice.GetParentsListBySearch(1,this.StandardId, this.SectionId,this.searchString).finally(() => { }).subscribe(
      response => {
         this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
        console.log(this.data);
        this.updateCurrentPage(0);
      },
      error => {
      });
  }
  public postParentChildUpdate(childInfo) {
    //this.addDepartmentmodel['schoolId'] = this.schoolId;
    this.parentchildservice.updateParentChildList(childInfo).finally(() => { }).subscribe(
      response => {
        // this.display = false;
        this.display = "none";
        this.getParentsList(this.bigCurrentPage, this.selectedRows);
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Updated Successfully' });
      },
      error => { });
  };

  private getClassSection() {
    this.noticeboardService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        this.Mappeddata = response;
        console.log('Mappeddata',this.Mappeddata);
       },
      error => {
      });
  };
  changeClass(event: any) {
    this.getSection(event);
    console.log(event,'e')
  };
  getSection(event: any) {
    var tempSection = [];
    tempSection = this.Mappeddata.filter(ele => ele['standardsName'] == event);
    for (let key in tempSection) {
      this.Sections = tempSection[key];
    }
    console.log(tempSection,'tempSection')
  };
  changeSection(event: any) {
    var tempSection = [];
    tempSection = this.Sections.Sections.filter(ele => ele['sectionName'] == event);
    this.addeventmodel['sectionName'] = tempSection[0]['sectionName'];
    this.getSection(event);
  };

  private getParentsList(pagenum, rows) {
    this.parentchildservice.GetParentsList(pagenum, rows).finally(() => { }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        console.log('pagination',this.bigTotalItems)
        this.data = response['items'];
      },
      error => {

      });
  };

  confirm() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        //Actual logic to perform a confirmation
      }
    });
  }
  viewChild(parentChild){
    this.childview =parentChild;
    // this.display = true;
    this.display = "block";
  }

  onCloseHandled() {
    this.display = "none";
  }

  editChild(parentChild) {
    // this.editDisplay = true;
    this.editDisplay = "block";
    this.childInfo = parentChild;
    this.changeClass(this.childInfo.Standard);
    console.log(parentChild,'parentChild')
  }

  onCloseHandled1() {
    this.editDisplay = "none";
  }

  pageChanged(event) {
    console.log(event);
    this.bigCurrentPage = event.page+1;
    this.selectedRows = event.rows;
    console.log("page",this.bigCurrentPage);
    console.log("rows",this.selectedRows);
    // this.getParentsList(event.page);

    if(!this.StandardId)this.StandardId='';
    if(!this.SectionId) this.SectionId='';
    if(!this.searchString) this.searchString='';
    this.parentchildservice.GetParentsListBySearch(this.bigCurrentPage,this.StandardId, this.SectionId,this.searchString).finally(() => { }).subscribe(
      response => {
         this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
        console.log(this.data);
      },
      error => {
      });
  }
  gotoAddParent() {
    this.router.navigate(['parentchild/addparentchild'])
  }*/
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parentchild/viewschool/parentchild_advancedQ.component.ts